import React from "react";
import { Props } from "./types";

function DeleteColumnIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <rect x="3" y="3" width="18" height="18" rx="1" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <line x1="9" y1="9" x2="9" y2="21" />
      <line x1="15" y1="9" x2="15" y2="21" />
      <line x1="10" y1="4" x2="14" y2="8" strokeWidth="2.5" />
      <line x1="14" y1="4" x2="10" y2="8" strokeWidth="2.5" />
    </svg>
  );
}

export { DeleteColumnIcon };
